import React from 'react';
import './footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  return (
    <div className='container-footer'>
      <div className='container-fluid'>
        <div className='row first-row'>
          <div className='col-md-9 col-12'>
            <div className='footer_logo_numbers'>
              <div className='footer_logo'>
                <img src='https://cdn.hidalgo.gob.mx/gobierno/images/logos/logo_gob.png' />
              </div>
              <div className='footer_numbers'>
                <div>
                  <p>911</p>
                  <p>Emergencia</p>
                </div>
                <div>
                  <p>089</p>
                  <p>Denuncia Anónima</p>
                </div>
              </div>
            </div>
          </div>
          <div className='col-md-3 col-12'>
            <div className='footer_contacto'>
              <h6><a href='https://gobierno.hidalgo.gob.mx/AvisoPrivacidad' target="_blank" rel="noopener noreferrer">Aviso de privacidad</a></h6>
              <h6>Contacto:</h6>
              <p>(01) 771 71 73 100<br/>Salazar Carlos Martínez Balmori #100 Col. Centro 42000</p>
              <p>Pachuca de Soto, Hidalgo, México</p>
            </div>
          </div>
        </div>
        <hr className='hr-gob' />
        <div className='row second-row'>
          <div className='col-sm-9 col-12'>
            <p>Copyrights © {currentYear} Todos los derechos reservados por Hidalgo de la Transformación</p>
          </div>
          <div className='col-sm-3 col-12'>
            <div className='footer_sociales'>
              <a href='https://www.facebook.com/dif.hidalgo' target="_blank" rel="noopener noreferrer"><img src="https://dif.hidalgo.gob.mx/img/logo_facebook_gold.svg"></img></a>
              <a href='https://www.instagram.com/_difhidalgo/' target="_blank" rel="noopener noreferrer"><img src="https://dif.hidalgo.gob.mx/img/logo_instagram_gold.svg"></img></a>  
              <a href='https://x.com/difhgo?lang=es' target="_blank" rel="noopener noreferrer"><img src="https://dif.hidalgo.gob.mx/img/logo_x_gold.svg"></img></a>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Footer